import { createCustomAction } from 'typesafe-actions';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$EDIT_FAVOURITE_ORDER/REQUESTED';
const BLOCKED = '$EDIT_FAVOURITE_ORDER/BLOCKED';
const APPROVED = '$EDIT_FAVOURITE_ORDER/APPROVED';
const SUCCEEDED = '$EDIT_FAVOURITE_ORDER/SUCCEEDED';
const FAILED = '$EDIT_FAVOURITE_ORDER/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      id: string;
      items?: ShadowItem[];
      name?: string;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, standardEmptyACC),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
